import React, { Fragment, useState } from 'react'
import { injectIntl } from 'react-intl'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import CircleCell from './CircleCell'
import MemberCell from './MemberCell'
import CaseCell from './CaseCell'
import RoleCell from './RoleCell'
import DateAddedCell from './DateSponsorCell'
import Options from './Options'
import StatusIcon from './StatusIcon'
import LatralityCell from './LatralityCell'

const CircleRow = ({ circle, user, subscriptionUser }) => {

	return (
		<TableRow data-testid="circle-row" key={circle.id} id={circle.id}>
			<TableCell data-testid="circle-row-status" align="left" size="medium" style={{ position: 'relative' }}>
				<div style={{
						backgroundColor: `${circle.phi ? '#444e5e' : '#86ceb4'}`,
						width: '4px',
						height: 'calc(100% - 16px)',
						position: 'absolute',
						left: 0,
						top: '8px'
				}}></div>
				<div>
					<StatusIcon circle={circle} />
				</div>
			</TableCell>
			<TableCell data-testid="circle-row-circle-cell" align="left" size="medium" style={{ minWidth: '180px' }}>
				<CircleCell circle={circle} />
			</TableCell>
			<TableCell data-testid="circle-row-circle-cell" align="left" size="medium" style={{ minWidth: '180px' }}>
				<LatralityCell isBilateral={circle.isBilateral} />
			</TableCell>
			<TableCell data-testid="circle-row-member" align="right" size="medium">
				<MemberCell circle={circle} />
			</TableCell>
			<TableCell data-testid="circle-row-case" align="right" size="medium">
				<CaseCell circle={circle} />
			</TableCell>
			<TableCell data-testid="circle-row-role">
				<RoleCell circle={circle} user={user} />
			</TableCell>
			<TableCell data-testid="circle-row-options" align="right" size="medium" style={{ padding: '5px 15px 5px 5px' }}>
				<Options circle={circle} user={user} subscriptionUser={subscriptionUser} />
			</TableCell>
		</TableRow>
	)
}

export default injectIntl(CircleRow)
